import React from 'react';
import { graphql, useFragment } from 'react-relay';

import type { PaymentActiveInstallmentCompleted_charge$key } from './__generated__/PaymentActiveInstallmentCompleted_charge.graphql.ts';
import type { PaymentActiveInstallmentCompleted_query$key } from './__generated__/PaymentActiveInstallmentCompleted_query.graphql.ts';
import PaymentCompleted from '../../completed/PaymentCompleted.tsx';

import type { ReactNode } from 'react';

type PaymentActiveInstallmentCompletedProps = {
  query: PaymentActiveInstallmentCompleted_query$key;
  charge: PaymentActiveInstallmentCompleted_charge$key;
};
const PaymentActiveInstallmentCompleted = (
  props: PaymentActiveInstallmentCompletedProps,
): ReactNode => {
  const query = useFragment<PaymentActiveInstallmentCompleted_query$key>(
    graphql`
      fragment PaymentActiveInstallmentCompleted_query on Query {
        ...PaymentCompleted_query
      }
    `,
    props.query,
  );

  const charge = useFragment<PaymentActiveInstallmentCompleted_charge$key>(
    graphql`
      fragment PaymentActiveInstallmentCompleted_charge on Charge {
        ...PaymentCompleted_charge
      }
    `,
    props.charge,
  );

  return <PaymentCompleted query={query} charge={charge} />;
};

export default PaymentActiveInstallmentCompleted;
